// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1891":"e5852b53","2033":"70f81d92","2171":"6a797a08","3436":"9daca94b","4877":"af0c9604"}[chunkId] + ".chunk.css";
};